import React from 'react';
import { motion } from 'framer-motion';
import { BrainCircuitIcon, TrendingDownIcon, DollarSignIcon } from 'lucide-react';
export function ProblemSection() {
  const problems = [{
    icon: <BrainCircuitIcon className="w-8 h-8 text-red-500" data-id="element-171" />,
    title: 'Parálisis por Análisis',
    desc: "Semanas eligiendo colores y meses buscando el 'producto perfecto'."
  }, {
    icon: <TrendingDownIcon className="w-8 h-8 text-red-500" data-id="element-172" />,
    title: 'Exceso de Información',
    desc: 'Miles de dólares en cursos que parecen enciclopedias interminables.'
  }, {
    icon: <DollarSignIcon className="w-8 h-8 text-red-500" data-id="element-173" />,
    title: 'Pérdida de Dinero',
    desc: 'Cada día que tu tienda no está publicada, estás perdiendo ventas y libertad.'
  }];
  return <section className="py-20 bg-navy-900 text-white px-4 relative overflow-hidden" data-id="element-174">
      <div className="absolute top-0 right-0 w-64 h-64 bg-red-500/10 rounded-full blur-[80px]" data-id="element-175"></div>

      <div className="max-w-5xl mx-auto relative z-10" data-id="element-176">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-177">
          <h2 className="text-4xl md:text-5xl font-bold mb-6 text-white" data-id="element-178">
            El Problema No Es Tu Capacidad... <br data-id="element-179" />
            <span className="text-red-400" data-id="element-180">Es El Exceso De Información</span>
          </h2>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto" data-id="element-181">
            La mayoría de los emprendedores latinos se quedan atrapados. Te han
            enseñado a construir un centro comercial cuando lo que necesitas es
            un{' '}
            <strong className="text-brandOrange-500" data-id="element-182">
              puesto de limonada digital
            </strong>{' '}
            que empiece a facturar hoy mismo.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-183">
          {problems.map((prob, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.2
        }} className="bg-navy-800 p-8 rounded-xl border border-navy-700 hover:border-red-500/50 transition-colors" data-id="element-184">
              <div className="bg-navy-900 w-16 h-16 rounded-full flex items-center justify-center mb-6 shadow-inner" data-id="element-185">
                {prob.icon}
              </div>
              <h3 className="text-2xl font-bold mb-3" data-id="element-186">{prob.title}</h3>
              <p className="text-gray-400 text-lg" data-id="element-187">{prob.desc}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}